import { render } from "./About.vue?vue&type=template&id=44ed60f6"
const script = {}
script.render = render

export default script